module.exports = "<gw-policy-contacts-summary-table\r\n        policy-number=\"$ctrl.policyNumber\"\r\n        page-size=\"$ctrl.pageSize\"\r\n        on-initial-load=\"$ctrl.totalAccountContacts = totalContactCount\"\r\n        table-description-key=\"gateway.contacts.common.components.Contacts.AccountContacts.Contacts associated with this policy only\"\r\n></gw-policy-contacts-summary-table>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/views/policy-contact-summary.html
// module id = 715
// module chunks = 0